import { Box } from '@chakra-ui/layout'
import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import moment from 'moment-timezone'
import 'moment/locale/it'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Dimmer, Form, Input, Loader, Message, Placeholder, TextArea } from 'semantic-ui-react'
import { baseViewDispatch, createAlert } from '../lib/util'
function MaterialEditor({ network, materialId, onSave, onCancel, defaultDescription, error, hide, info, removeAll, show, success, warning }) {
    const [material, setMaterial] = useState(null)
    const [status, setStatus] = useState(null)
    const [dirty, setDirty] = useState(false)

    useEffect(() => {
        if (materialId) {
            network.getMaterial(materialId).then((data) => {
                // console.log('Got material', data.data)
                setMaterial(data.data)
            })
        } else {
            setMaterial({
                pricePerUnit: 1,
                unit: 'g',
                materialCode: '',
                materialDescription: defaultDescription ? defaultDescription : 'Descrizione',
            })
        }
    }, [materialId])

    const handleInput = (event) => {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        setMaterial({
            ...material,
            [name]: value,
        })
    }

    const save = () => {
        network
            .createMaterial(material)
            .then((data) => {
                // console.log('Got material', data.data)
                setMaterial(data.data)
            })
            .then((result) => {
                success(createAlert('Operazione completata.', 'Operazione avvenuta con successo!', 'Ok', () => {}))
                setStatus('success')
                if (onSave) {
                    onSave(result)
                }
            })
            .catch((error) => {
                error(createAlert('Errore nel tentativo di contattare il server', 'Riprova piú tardi'))
                setStatus('error')
            })
    }

    if (!material) {
        return (
            <Box p={6}>
                <Dimmer active>
                    <Loader />
                </Dimmer>

                <Placeholder>
                    <Placeholder.Header image>
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Header>
                    <Placeholder.Paragraph>
                        <Placeholder.Line />
                        <Placeholder.Line />
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Paragraph>
                </Placeholder>
            </Box>
        )
    }

    const { pricePerUnit, unit, materialCode, materialDescription } = material

    return (
        <View fullw fullh column between style={{ marginTop: 20, paddingLeft: 20, paddingRight: 20 }}>
            <Form success={status === 'success'} error={status === 'error'} warning={status === 'warning'}>
                <Box p={6}>
                    <Box textStyle="header" as="h1">Anagrafica materiale</Box>
                    <Form.Group widths="equal">
                        <Form.Field
                            id="form-input-control-material-name"
                            control={TextArea}
                            label={<span className="label">Descrizione Materiale</span>}
                            name="materialDescription"
                            value={materialDescription}
                            onChange={(e) => handleInput(e)}
                            placeholder=""
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            id="form-input-control-material-code"
                            control={Input}
                            label={<span className="label">Codice materiale (opzionale)</span>}
                            name="materialCode"
                            value={materialCode}
                            onChange={(e) => handleInput(e)}
                            placeholder=""
                        />
                        <Form.Field
                            id="form-input-control-material-price"
                            control={Input}
                            label={<span className="label">Prezzo per unità</span>}
                            name="pricePerUnit"
                            value={pricePerUnit}
                            type="number"
                            onChange={(e) => handleInput(e)}
                            placeholder=""
                            step="0.01"
                        />
                        <Form.Field
                            id="form-input-control-material-unit"
                            control={Input}
                            label={<span className="label">Unità di misura</span>}
                            name="unit"
                            value={unit}
                            onChange={(e) => handleInput(e)}
                            placeholder=""
                        />
                    </Form.Group>
                </Box>

                <Form.Group>
                    <Form.Field
                        style={{ marginTop: 16 }}
                        id="form-button-control-save"
                        control={Button}
                        content="Salva"
                        onClick={() => {
                            save()
                        }}
                        color="green"
                    />
                    <Form.Field
                        style={{ marginTop: 16 }}
                        id="form-button-control-cancel"
                        control={Button}
                        content="Annulla"
                        onClick={() => {
                            if (onCancel) {
                                onCancel()
                            }
                        }}
                        color="red"
                    />
                </Form.Group>
                <Message success header="Form completato con successo" content="Materiale inserito con successo!" />
                <Message error header="Errore" content="Errore del server, riprova piu' tardi." />
                <Message warning header="Errore inserimento" list={['Ricontrolla i dati inseriti']} />
            </Form>
        </View>
    )
}

const mapStateToProps = (state, ownProps) => {
    let { login } = state

    return {
        login,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...baseViewDispatch(dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(MaterialEditor)))
